angular.module('app.entity.audit').constant('STRATEGY_CHANGE_ACTIONS', {
    SET_REVISION_STRATEGY: 'set-revision-strategy',
    UPDATE_REVISION_STRATEGY: 'update-revision-strategy',
});
